<div class="container">
  <div class="col-md-12 mb-md-0 mb-12">

    <!-- Grid row -->
    <div class="row">
      <div class="col-md-2">

      </div>
      <div class="col-md-8">
        <br><br>
        <h4 class="text-bold">
          Documentos de la empresa
        </h4>
        <br><br>

        <div class="row document-types">
          <!--  -->


          <div class="col-sm-6" *ngFor="let file of typeFiles; let i = index" [attr.for]="'file' + i">
            <label class="document-type">
              <div class="icon-type" [ngClass]="{'file-loaded': file.fileRegistered}">
                <img *ngIf="!file.fileRegistered" src="/assets/svg/icons/icon-upload.svg" alt="">
                <img *ngIf="file.fileRegistered" src="/assets/svg/icons/icon-correct.svg" alt="">
              </div>
              <div class="data-type">
                <label class="label-field title-letter">{{file.title}}</label>
                <br>
                <label class="label-field label-file">
                  <a class="file-name-container" *ngIf="file.name" (click)="downloadFile(file)" target="_blank">
                    <i class="fas fa-paperclip"></i>
                    <span class="file-name" *ngIf="file.fileRegistered" title="{{file.name}}">{{file.name}}</span>
                    <span class="file-name" *ngIf="!file.fileRegistered" title="Sin archivo">Sin archivo</span>
                    <span class="file-size" *ngIf="file.size" title="{{file.size}}">{{file.size}}</span>
                  </a>
                </label>
              </div>
            </label>
          </div>

        </div>

      </div>
      <div class="col-md-2">

      </div>
    </div>


  </div>
</div>
